import type { Agent } from '@edge/spark/io-dashboards'

export const sortAgentNames = (a: Agent, b: Agent): number => {
    if (typeof a?.firstName === 'string' && typeof b?.firstName === 'string') {
        const res = a.firstName.localeCompare(b.firstName, 'en', {
            sensitivity: 'base',
        })
        // https://stackoverflow.com/a/6720249
        if (res === 0) {
            if (typeof a?.lastName === 'string' && typeof b?.lastName === 'string') {
                return a.lastName.localeCompare(b.lastName, 'en', {
                    sensitivity: 'base',
                })
            }
        }
        return res
    }
    return 0
}
